export const SET_ATTORNEY_DATA = 'SET_ATTORNEY_DATA';
export const SET_SCHOOL_DATA = 'SET_SCHOOL_DATA';
export const SET_CLIENT_DATA = 'SET_CLIENT_DATA';
